import NotFound from '@/frame/404.vue'
import MainLayout from '@/frame/main/MainLayout.vue'
import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/wxUploadPdf',
      component: () => import('@/pages/wxUploadPdf.vue'),
      name: '',
      hidden: true
    },{
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true
  }, {
    path: '/',
    hidden: true,
    redirect: {
      path: '/main/desktop'
    }
  }, {
    path: '*',
    hidden: true,
    redirect: {
      path: '/404'
    }
  }, {
    path: "/main",
    component: MainLayout,
    redirect: "/main/desktop",
    name: "desktop",
    children: [{
      path: "desktop",
      name: "首页",
      component: () => import('@/pages/desktop.vue'),
    },
      {
        path: "solutionAndServices",
        name: "解决方案和服务",
        component: () => import('@/pages/solutions-and-services/index.vue')
      },
      {
        path: "aboutUs",
        name: "关于我们",
        component: () => import('@/pages/about-us/index.vue')
      },
      {
        path: "solutionDetails",
        name: "解决方案详情",
        component: () => import('@/pages/solutions-and-services/solutionDetails.vue')
      },
      {
        path: "productDetails",
        name: "产品详情",
        component: () => import('@/pages/solutions-and-services/productDetails.vue')
      },
      {
        path: "classicCase",
        name: "经典案例",
        component: () => import('@/pages/classic-case/index.vue')
      },
      {
        path: "caseDetails",
        name: "案例详情",
        component: () => import('@/pages/classic-case/caseDetails.vue')
      },
      {
        path: "recruitment",
        name: "招聘",
        component: () => import('@/pages/recruitment/index.vue')
      },
      {
        path: "news",
        name: "新闻中心",
        component: () => import('@/pages/news/news-center.vue'),
        meta:{
          keepAlive:true
        }
      },{
        path: "newsDetails",
        name: "新闻中心",
        component: () => import('@/pages/news/news-details.vue')
      },
      {
        path: "joinUs",
        name: "加入我们",
        component: () => import('@/pages/join-us/index.vue')
      }
    ]
  }]

})



// WEBPACK FOOTER //
// ./src/router/index.js